// publicFeaturedProductItem.reducer
import { publicFeaturedProductItemConstants as P } from '../actions/constants'

const initialState = {
    itemObj: {},
    products: [],
    loading: false,
    error: null,
    message: "",
};

export default (state = initialState, action) => {
    switch (action.type) {
        case P.GET_PUBLIC_FEATURED_PRODUCT_ITEM_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };

        case P.GET_PUBLIC_FEATURED_PRODUCT_ITEM_SUCCESS: {
            const itemObj = action.payload?.featuredProductItemObj || {};
            const products = Array.isArray(itemObj.products) ? itemObj.products : [];

            return {
                ...state,
                loading: false,
                itemObj,
                products,
                message: action.payload?.message || "",
                error: null,
            };
        }

        case P.GET_PUBLIC_FEATURED_PRODUCT_ITEM_FAILURE:
            return {
                ...state,
                loading: false,
                itemObj: {},
                products: [],
                message: action.payload?.message || "",
                error: action.payload,
            };

        case P.RESET_PUBLIC_FEATURED_PRODUCT_ITEM:
            return initialState;

        default:
            return state;
    }
};